// extracted by mini-css-extract-plugin
export default {"wrapper":"JB-z","viewport":"KB-z","container":"LB-z","slide":"MB-z"};